/**
 * Reading the School dashboard's cards for the pages that draw their own tables
 * (Mehreen's layouts): each page keeps its own headers and row shape, and these
 * helpers fill that shape from the card the P1 Dashboard Data Map names.
 *
 * They only READ. A missing card or column gives "—", never a stand-in value.
 *
 * The readers are the shared implementation in NetworkDashboard/networkData.js
 * (one place that knows the card shapes and the n < 10 suppression flag); this
 * module re-exports them so the School pages keep their import path.
 */
export {cellText, formatCell, rowsFrom, distinct} from '../NetworkDashboard/networkData';

/** A card by section and card code, e.g. ('S_18', 'C_6') for SD.S_18.C_6. */
export const findCard = (dashboardData, sectionCode, cardCode) =>
    ((dashboardData?.cards?.sections || []).find((s) => s.section_code === sectionCode)?.cards || [])
        .find((c) => c.card_code === cardCode) || null;

/** First letter upper-cased for display ("grade 7" → "Grade 7"); the value itself is unchanged. */
export const labelCase = (v) => (typeof v === 'string' && v ? v.charAt(0).toUpperCase() + v.slice(1) : v);
